import React from "react";
import "../../../Styles/Upload.scss";
import { Icon } from "@cadmakers-ui/icons";
import { ListGroupItem } from "reactstrap";
import { FeedbackFile } from "../../../Models/FeedbackFile";
import { ImagePreviewModal } from "../ImagePreviewModal";
import pdfImage from "../../../Images/pdf.jpg";
import pptImage from "../../../Images/powerpoint.jpg";
import docImage from "../../../Images/word.jpg";
import xlsImage from "../../../Images/excel.jpg";
import txtImage from "../../../Images/text.jpg";
import vidImage from "../../../Images/video.png";
import gifImage from "../../../Images/gif.png";
import styles from "../../../Styles/FeedbackFileManagerItem.module.scss";
import iconStyles from "../../../../Common/Styles/Icons.module.scss";

type Props = {
  file: FeedbackFile;
  onDelete: () => void;
};

export default class FeedbackFileManagerItem extends React.Component<Props> {
  onDeleteClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    event.stopPropagation();

    this.props.onDelete();
  };

  getImageUrl = () => {
    switch (this.props.file.extension) {
      case ".pdf":
        return pdfImage;
      case ".ppt":
        return pptImage;
      case ".pptx":
        return pptImage;
      case ".docx":
        return docImage;
      case ".doc":
        return docImage;
      case ".xlsx":
        return xlsImage;
      case ".xls":
        return xlsImage;
      case ".csv":
        return xlsImage;
      case ".txt":
        return txtImage;
      case ".mp4":
        return vidImage;
      case ".gif":
        return gifImage;
      default:
        return "";
    }
  };

  render() {
    const closeClassName = `gallery-delete ${styles.closeIcon}`;

    return (
      <ListGroupItem
        className={styles.itemRow}
        onDragOver={e => {
          e.preventDefault();
          return false;
        }}
        onDrop={e => {
          e.preventDefault();
          return false;
        }}
      >
        <a href={this.props.file.url} target="_blank" rel="noopener noreferrer">
          <img src={this.getImageUrl()} className={styles.itemImage} />
          <div className={styles.itemFileName}>{this.props.file.filename}</div>
          <a
            className={closeClassName}
            onClick={this.onDeleteClick}
            title="Click here to remove this fille"
          >
            <span>
              <Icon
                appName="GeneralLayout"
                assetName="GENERAL_L_RemoveX"
                className={iconStyles.smallIcon}
              />
            </span>
          </a>
        </a>
      </ListGroupItem>
    );
  }
}
